import { render, staticRenderFns } from "./HomeworkPositionEdit.vue?vue&type=template&id=8ed40144&scoped=true&"
import script from "./HomeworkPositionEdit.vue?vue&type=script&lang=ts&"
export * from "./HomeworkPositionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./HomeworkPositionEdit.vue?vue&type=style&index=0&id=8ed40144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed40144",
  null
  
)

export default component.exports